/**
 * Calculation Engine Tab
 * For Media Devoted | Created By Ciro Autiero
 */

import { FC, ReactNode } from 'react';
import type { FormulaConfig } from '@trafficpulse/shared';

import MasterFormulaSliders from './calculation/MasterFormulaSliders';
import BoundsEditor from './calculation/BoundsEditor';
import CalculationHelpContent from './calculation/CalculationHelpContent';
import { HowItWorksPanel } from '../components/help';

export interface CalculationEngineTabProps {
  formula: FormulaConfig;
  minWeight: number;
  maxWeight: number;
  onFormulaChange: (next: FormulaConfig) => void;
  onBoundsChange: (minWeight: number, maxWeight: number) => void;
  /** Library set controls — rendered inside the clipboard bar. */
  libraryActions?: ReactNode;
}

const CalculationEngineTab: FC<CalculationEngineTabProps> = ({
  formula,
  minWeight,
  maxWeight,
  onFormulaChange,
  onBoundsChange,
  libraryActions,
}) => (
  <div className="space-y-4">
    <HowItWorksPanel title="Custom formula" storageKey="fopt:help:calculation">
      <CalculationHelpContent />
    </HowItWorksPanel>
    <BoundsEditor
      minWeight={minWeight}
      maxWeight={maxWeight}
      onChange={onBoundsChange}
    />
    <MasterFormulaSliders
      formula={formula}
      onChange={onFormulaChange}
      libraryActions={libraryActions}
    />
  </div>
);

export default CalculationEngineTab;
